import { DefaultTheme, TColorProp } from 'styled-components';

export function getThemeColor(theme: DefaultTheme, prop: TColorProp): string {
  return theme[prop as keyof DefaultTheme] as string;
}
